import React, { Component } from 'react';
import Vas from '../../../Vas';
//import '../../../css/CustomerCreateContract.css';
import { LinkButton } from 'component-lib';
import $ from 'jquery';

class CustomerVerificationUploadSuccess extends Component
{

  constructor(props)
  {
    super(props);
    this.state = {};
    this.CustomerId = props.match.params.CustomerId
  }
 
  componentDidMount(){
    this.FontSizeClick();
  }

  FontSizeClick(condition){
    var schriftgröße = localStorage.getItem('Schriftgröße');

    //Schriftgröße bei Klick in 2er Schritten erhöhen

      if(schriftgröße != null){
          if(condition){

              switch(schriftgröße){
                  case "0":
                    
                    $("#UploadSuccessText").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $("#LinkLogin").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    
                    localStorage.setItem('Schriftgröße', '1');

                  break;
                  case "1":
                    
                    $("#UploadSuccessText").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $("#LinkLogin").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      
                    localStorage.setItem('Schriftgröße', '2');
                  break;
                  case "2":
                    
                    $("#UploadSuccessText").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $("#LinkLogin").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                    localStorage.setItem('Schriftgröße', '3');
                  break;
                  case "3":
                    
                    $("#UploadSuccessText").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $("#LinkLogin").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                    localStorage.setItem('Schriftgröße', '4');
                  break;
                  case "4":
                    
                    $("#UploadSuccessText").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $("#LinkLogin").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                                  
                    localStorage.setItem('Schriftgröße', '5');
                  break;
                  case "5":
                    
                    $("#UploadSuccessText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $("#LinkLogin").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    localStorage.setItem('Schriftgröße', '0');
                  break;
              }

          } else {
            switch(schriftgröße){
              case "0":
                
                    $("#UploadSuccessText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $("#LinkLogin").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

              break;
              case "1":              
              
                    $("#UploadSuccessText").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $("#LinkLogin").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                   
              break;
              case "2":
                
                    $("#UploadSuccessText").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $("#LinkLogin").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

              break;
              case "3":
                
                    $("#UploadSuccessText").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $("#LinkLogin").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

              break;
              case "4":             
              
                    $("#UploadSuccessText").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $("#LinkLogin").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

              break;
              case "5":
                
                    $("#UploadSuccessText").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $("#LinkLogin").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");


              break;
            }
          }
      }
  }

  render()
  {

    this.FontSizeClick();

    return (
      <div
        className={"PaymentContainer"}
      >
        <div className={"form"}>
          <table >
            <thead>
              <tr>
                <th style={{fontSize:'large',width:'400px'}} colSpan={2}>
                <h2>{Vas.Resources.Labels["ConfirmationUploadSuccess"]}</h2>
                  <br />
                  <br />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr>
                <td id={"UploadSuccessText"} style={{ fontSize:'14px', textAlign: 'right' }}>{Vas.Resources.Labels["LinkLoginPlural"]}</td>
                <td style={{ textAlign: 'left' }}>
                  <LinkButton
                  Text={Vas.Resources.Labels["PersonalDataLink"]}
                  Id={"LinkLogin"}
                  OnClick={()=>{Vas.GetView("CustomerCard", { Id :this.props.match.params.CustomerId }, true);}} /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
export default CustomerVerificationUploadSuccess;
